import { Suspense, lazy } from 'react';
import Loader from '../customs/Customspinner/spinner';

const Main = lazy(() => import('../components/changePassword/main')); 

const ChangePassword = () => {
    return (
        <Suspense fallback={<Loader/>}>
        <Main/>
    </Suspense>
    )
}

export default ChangePassword;